import { createContext, useContext, type ReactNode } from "react";

import type { AgentArtifact } from "../api/e2e";

export type AgentArtifactOpenAction = (
  artifact: AgentArtifact,
) => void | Promise<void>;

const AgentArtifactActionContext =
  createContext<AgentArtifactOpenAction | null>(null);

export function AgentArtifactActionProvider({
  onOpenArtifact,
  children,
}: {
  onOpenArtifact: AgentArtifactOpenAction;
  children: ReactNode;
}) {
  return (
    <AgentArtifactActionContext.Provider value={onOpenArtifact}>
      {children}
    </AgentArtifactActionContext.Provider>
  );
}

export function useAgentArtifactOpenAction(): AgentArtifactOpenAction | null {
  return useContext(AgentArtifactActionContext);
}
